/**
 *
 *
 * @author Arian Khosravi <arian.khosravi@aofl.com>
 */
class ServerTime {
  /**
   *
   * @param {String} [label='defaultLabel']
   */
  static time(label = 'defaultLabel') {
    ServerTime[label] = {
      start: Math.round(Date.now() / 1000),
      end: 0,
      mean: 0,
      base: 0,
      delta: 0
    };
  }
  /**
   * @param {Number} serverTime
   * @param {String} [label='defaultLabel']
   */
  static timeEnd(serverTime, label = 'defaultLabel') {
    ServerTime[label].end = Math.round(Date.now() / 1000);
    ServerTime[label].mean = Math.round((ServerTime[label].start + ServerTime[label].end) / 2);
    ServerTime[label].base = serverTime;
    ServerTime[label].delta = serverTime - ServerTime[label].mean;
  }
  /**
   *
   * @param {String} [label='defaultLabel']
   * @return {Number}
   */
  static getAdjustedTime(label = 'defaultLabel') {
    if (!ServerTime.hasOwnProperty(label)) {
      throw new Error(`ServerTime profile ${label} doesn't exist`);
    }

    return Math.round(Date.now() / 1000) + ServerTime[label].delta;
  }
}

export {
  ServerTime
};
